module.exports = __webpack_public_path__ + "static/media/3d-viewer.27d2f569.svg";